var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedorChat"},[_c('MenuLateral'),_c('div',{staticClass:"seccionChat",attrs:{"id":"chat"}},[_c('navbar'),_c('div',{staticClass:"container-fluid"},[_c('componente-superior'),_c('transferir-chat')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }